import { render, staticRenderFns } from "./WorkOrderQaQcQuestion.vue?vue&type=template&id=2f6ed0e4&%3Akey=componentKey"
import script from "../../scripts/pages/WorkOrderQaQcQuestion.js?vue&type=script&lang=js&external"
export * from "../../scripts/pages/WorkOrderQaQcQuestion.js?vue&type=script&lang=js&external"
import style0 from "./WorkOrderQaQcQuestion.vue?vue&type=style&index=0&id=2f6ed0e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports